import { ICharacter } from "@next-platform/client-common-core";
import React, { Dispatch, SetStateAction } from "react";

import { BlockCreatorModal } from "@/components";
import CapabilityShareCharacterModal from "@/components/common/CapabilityShareCharacterModal";
import ConfirmationModal from "@/components/common/ConfirmationModal";

interface CharacterModalsProps {
  characterInfo: ICharacter | null;

  shareModal?: {
    visible: boolean;
    setVisible: Dispatch<SetStateAction<boolean>>;
    characterId: string;
    currentUrlOrigin: string;
    applicationName: string;
  };

  blockModal?: {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    isLoading?: boolean;
  };

  deleteModal?: {
    visible: boolean;
    setVisible: (visible: boolean) => void;
    onConfirm: () => Promise<void>;
    isLoading?: boolean;
  };
}

const CharacterModals = ({ characterInfo, shareModal, blockModal, deleteModal }: CharacterModalsProps) => {
  const shareModalNode = shareModal ? (
    <CapabilityShareCharacterModal
      visible={shareModal.visible}
      setShowShare={shareModal.setVisible}
      characterId={shareModal.characterId}
      characterName={characterInfo?.name}
      shareUrl={`${window.location.origin}/chat/${shareModal.characterId}`}
    />
  ) : null;

  return (
    <>
      {shareModalNode}

      {blockModal?.visible && (
        <BlockCreatorModal
          creatorId={characterInfo?.creator_user_id as string}
          creatorUsername={characterInfo?.creator_username as string}
          isVisible={blockModal.visible}
          onClose={blockModal.setVisible}
        />
      )}

      {deleteModal && (
        <ConfirmationModal
          heading="Remove Chatbot"
          onUserConfirmation={deleteModal.onConfirm}
          actionButtonColor="error"
          actionButtonText="Remove"
          discardButtonText="Cancel"
          isVisible={deleteModal.visible}
          isLoading={deleteModal.isLoading || false}
          handleClose={() => !deleteModal.isLoading && deleteModal.setVisible(false)}
          confirmationMessage={`Are you sure you want to remove this chatbot? This action cannot be undone.`}
        />
      )}
    </>
  );
};

export default CharacterModals;
